<script setup lang="ts">
import ProgressSpinner from "primevue/progressspinner"
import { guriga } from "./stores/guriga";
import { useDocumentTitle } from "./composables/useTitle";
const { showGuriga } = guriga()
useDocumentTitle();
</script>

<template>
  <router-view />
  <div v-if="showGuriga" class="fixed inset-0 flex items-center justify-center z-[9999]">
    <ProgressSpinner strokeWidth="8" style="width:50px; height:50px"
      :pt="{
        circle: { class: '!stroke-sky-500 !opacity-100' }
      }"/>
  </div>
</template>
